import {
  buildIngredientLinkedOption, getRuleField, isIngredientLinkedRule, matchesLinkedRule,
} from "./linkedRules";
import { buildOperationalConsumptions, isBeverageCategory } from "../local/orderModel";

export { isBeverageCategory };

export const getBeverageIngredientRules = (product, rules = []) =>
  rules.filter((rule) => isIngredientLinkedRule(rule) && matchesLinkedRule(rule, product));

// A selectable variety replaces its recipe entry; it is not an extra serving.
export const withoutBeverageVarietyIngredients = (product, rules = []) => {
  const ingredientIds = new Set(getBeverageIngredientRules(product, rules)
    .map((rule) => getRuleField(rule, "target", "Ingredient")));
  if (!ingredientIds.size) return product;
  const keep = (ingredient) => !ingredientIds.has(String(ingredient.id || ingredient.ingredientId || ingredient.ingredient_id));
  return { ...product,
    ingredients: (product.ingredients || product.ingredientes || []).filter(keep),
    ingredientes: (product.ingredientes || product.ingredients || []).filter(keep),
  };
};

export const resolveBeverageSelection = (product, selections = [], rules = []) => {
  const applicable = getBeverageIngredientRules(product, rules);
  const selected = (Array.isArray(selections) ? selections : []).filter((entry) => entry.targetIngredientId || String(entry.productId || "").startsWith("ingredient:"));
  if (!applicable.length) return { required: false, valid: selected.length === 0, option: null };
  if (selected.length !== 1) return { required: true, valid: false, option: null };
  const ingredientId = selected[0].targetIngredientId || String(selected[0].productId).slice(11);
  const rule = applicable.find((entry) => getRuleField(entry, "target", "Ingredient") === ingredientId);
  const option = rule && buildIngredientLinkedOption(rule);
  return { required: true, valid: Boolean(option?.active), option: option?.active ? option : null };
};

export const buildBeverageConsumptions = (product, item, rules = []) => {
  const resolved = resolveBeverageSelection(product, item?.linkedSelections, rules);
  return resolved.option ? buildOperationalConsumptions(resolved.option, { quantity: item.quantity || 1 }) : [];
};
